
import React from 'react';
import { MapPin, Instagram } from 'lucide-react';

const LocationSection = () => {
  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-floresta-acaiDark text-center mb-8">
          Onde vai ser?
        </h2>
        
        <div className="bg-gradient-to-br from-floresta-pistachio/30 to-floresta-cream/30 shadow-lg rounded-xl p-6 md:p-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-start space-x-3">
              <MapPin className="w-8 h-8 text-floresta-acaiDark shrink-0 mt-1" />
              <div>
                <h3 className="text-xl font-bold text-floresta-acaiDark">Endereço</h3>
                <p className="text-lg">Av. do Taboão, 4052</p>
                <p className="text-lg">São Bernardo do Campo</p>
              </div>
            </div>
            
            <div className="h-20 w-px bg-floresta-acai/20 hidden md:block"></div>
            
            <a 
              href="https://www.instagram.com/florestasorveteseacai" 
              target="_blank" 
              rel="noreferrer"
              className="flex items-center space-x-3 group text-floresta-acaiDark hover:text-floresta-acai transition-colors duration-300"
            >
              <Instagram className="w-8 h-8 group-hover:scale-110 transition-transform duration-300" />
              <div>
                <h3 className="text-xl font-bold">Siga-nos</h3>
                <p className="text-lg">@florestasorveteseacai</p>
              </div>
            </a>
          </div>
          
          <div className="mt-8">
            <div className="rounded-lg overflow-hidden shadow-md h-64 md:h-80">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3655.0383848036546!2d-46.58747548902788!3d-23.655194166272084!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce43abc2c1b9d1%3A0x77579f01b3ded586!2sAv.%20do%20Tabo%C3%A3o%2C%204052%20-%20Jardim%20Maria%20Tereza%2C%20S%C3%A3o%20Bernardo%20do%20Campo%20-%20SP!5e0!3m2!1spt-BR!2sbr!4v1651253869442!5m2!1spt-BR!2sbr" 
                width="100%" 
                height="100%" 
                style={{ border: 0 }} 
                allowFullScreen 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
